import { render } from "./ConsumerMessage.vue?vue&type=template&id=7b352812"
import script from "./ConsumerMessage.vue?vue&type=script&lang=js"
export * from "./ConsumerMessage.vue?vue&type=script&lang=js"

import "./ConsumerMessage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__